import { css } from 'linaria';
import { cardsGrid } from 'components/items-layout/base';
import { breakpointMediumTablet } from '@pocket/web-ui';
import { breakpointSmallTablet } from '@pocket/web-ui';
import { breakpointTinyTablet } from '@pocket/web-ui';
export const contentLayout = "c1suslhj";

require("./content-layout.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./content-layout.js");